import { call, put, takeLatest } from 'redux-saga/effects';
import handleException from '../services/handleException';
import { listChannel } from '../utils/channel';
import { GET_LIST_CHANNEL_ORDER, GET_LIST_CHANNEL_ORDER_SUCCESS } from './../actions/ordersAction';

function* getListChannelOrderSaga() {
    yield takeLatest(GET_LIST_CHANNEL_ORDER, getListChannelOrderHandle)
}

function* getListChannelOrderHandle(action) {
    try {
        const response = yield call(listChannel, action.payload)

        if (response.data.code === 10001) {
            yield put({ type: GET_LIST_CHANNEL_ORDER_SUCCESS, payload: response })
        } else {
            handleException(response)
        }
    } catch (error) {
        handleException(error)
    }
}

export default getListChannelOrderSaga


// WEBPACK FOOTER //
// ./src/sagas/getListChannelOrderSaga.js